import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons'

import { useTranslationRankmi } from 'helpers/translations.helper'
import { Banner, BannerStrong, BannerText } from './styled'

export const NormativeDc3LessonsAlert: React.FC = () => {
  const t = useTranslationRankmi({
    prefix: 'administration.lessons.normativeDc3Banner',
  })

  return (
    <Banner>
      <FontAwesomeIcon icon={faInfoCircle} aria-hidden />
      <BannerText>
        <BannerStrong>{t('intro')}</BannerStrong>
        {t('body')}
      </BannerText>
    </Banner>
  )
}

export default NormativeDc3LessonsAlert
